var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "sticky",
          rawName: "v-sticky",
          value: { zIndex: 1000, stickyTop: 63, disabled: false },
          expression: "{ zIndex: 1000, stickyTop: 63, disabled: false}"
        }
      ],
      staticClass: "table-header"
    },
    [
      _c(
        "b-row",
        { attrs: { "align-v": "center", "align-h": "between" } },
        [
          _c(
            "b-col",
            { staticClass: "table-header-actions" },
            [
              _c(
                "transition",
                { attrs: { name: "fade" } },
                [
                  _vm.topButton
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover.bottom",
                              modifiers: { hover: true, bottom: true }
                            }
                          ],
                          staticClass: "mr-1",
                          attrs: {
                            size: "sm",
                            disabled: !_vm.toTopActive,
                            title: "Подняться в начало",
                            variant: "light"
                          },
                          on: { click: _vm.toTop }
                        },
                        [_c("i", { staticClass: "fas fa-arrow-alt-up" })]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm._t("beforeActions"),
              _vm._v(" "),
              _c("table-header-actions-toolbar", {
                attrs: {
                  actions: _vm.actionsToolbar,
                  "window-width": _vm.windowWidth,
                  show: _vm.showActionsToolbar,
                  "collapse-count": !!_vm.$slots.beforeActions ? 2 : 3
                },
                on: { action: _vm.doAction }
              }),
              _vm._v(" "),
              _vm._t("afterActions")
            ],
            2
          ),
          _vm._v(" "),
          _vm.totalRows
            ? _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _vm._t("beforePagination"),
                  _vm._v(" "),
                  _c("fup-pagination", {
                    staticClass: "m-0",
                    attrs: {
                      size: "sm",
                      "total-rows": _vm.totalRows,
                      minimize: _vm.windowWidth < 1366,
                      value: _vm.currentPage,
                      "hide-goto-end-buttons": _vm.windowWidth < 1024,
                      "per-page": _vm.perPageData
                    },
                    on: { input: _vm.changePage }
                  }),
                  _vm._v(" "),
                  _vm._t("afterPagination")
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-col",
            { class: { "pl-0": _vm.totalRows }, attrs: { cols: "auto" } },
            [
              typeof _vm.$listeners.search === "function"
                ? _c("table-header-searcher", {
                    attrs: {
                      minimize: _vm.windowWidth < 1366,
                      value: _vm.searchQuery
                    },
                    on: { input: _vm.setSearchQuery, search: _vm.search }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.perPageData || _vm.configurableTable
                ? _c(
                    "b-dropdown",
                    {
                      staticClass: "m-0",
                      attrs: {
                        variant: _vm.isTableFieldsChanged ? "warning" : "light",
                        right: "",
                        size: "sm",
                        "no-caret": _vm.windowWidth < 1366
                      }
                    },
                    [
                      _c("template", { slot: "button-content" }, [
                        _c("i", { staticClass: "fas fa-cog" })
                      ]),
                      _vm._v(" "),
                      _vm.configurableTable
                        ? _c(
                            "b-dropdown-item-button",
                            { on: { click: _vm.openTableConfigurator } },
                            [
                              _vm._v(
                                "\n                    Настроить таблицу\n                    "
                              ),
                              _vm.isTableFieldsChanged
                                ? _c(
                                    "b-badge",
                                    { attrs: { variant: "warning" } },
                                    [_vm._v("Изменено")]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.perPageData
                        ? [
                            _vm.configurableTable
                              ? _c("b-dropdown-divider")
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.perPageVariants, function(item) {
                              return _c(
                                "b-dropdown-item-button",
                                {
                                  key: item.value,
                                  attrs: {
                                    active: item.value === _vm.perPageData
                                  },
                                  on: {
                                    click: function($event) {
                                      _vm.perPageData = item.value
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(item.text) +
                                      "\n                    "
                                  )
                                ]
                              )
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "b-dropdown-item-button",
                        { on: { click: _vm.toggleTopButtonState } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                _vm.topButton
                                  ? 'Выключить кнопку "Вверх"'
                                  : 'Включить кнопку "Вверх"'
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.$slots["buttons"]
                ? _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [_vm._t("buttons")],
                    2
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.$slots["filters"]
        ? _c(
            "div",
            { staticClass: "labels" },
            [
              _c(
                "b-row",
                { attrs: { "align-h": "between" } },
                [
                  _c("b-col", [_vm._t("filters")], 2),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { cols: "auto" } },
                    [
                      _c(
                        "b-button",
                        {
                          attrs: { size: "sm", variant: "warning" },
                          on: { click: _vm.discardFilters }
                        },
                        [
                          _c("i", { staticClass: "fas fa-minus-hexagon" }),
                          _vm._v(
                            "\n                    Очистить\n                "
                          )
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.$slots.labels
        ? _c("div", { staticClass: "labels" }, [_vm._t("labels")], 2)
        : _vm._e(),
      _vm._v(" "),
      _c(
        "portal",
        { attrs: { to: "app" } },
        [
          _vm.configurableTable
            ? _c(
                "modal",
                {
                  attrs: {
                    name: "table-configurator",
                    width: 480,
                    height: "auto",
                    scrollable: true
                  }
                },
                [
                  _c(
                    "fup-modal-constructor",
                    {
                      attrs: { title: "Настройка таблицы", icon: "wrench" },
                      on: { close: _vm.closeTableConfigurator }
                    },
                    [
                      _c(
                        "template",
                        { slot: "default" },
                        [
                          _vm.tableFields
                            ? [
                                _c("h3", [_vm._v("Колонки таблицы")]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "Вы можете отключить ненужные колонки и изменить их порядок"
                                  )
                                ]),
                                _vm._v(" "),
                                _vm.configuredTableFields &&
                                _vm.configuratorModal
                                  ? _c(
                                      "fup-draggable",
                                      {
                                        staticClass: "list-group",
                                        attrs: { tag: "ul", handle: ".handle" },
                                        on: { change: _vm.saveTableConfig },
                                        model: {
                                          value: _vm.configuredTableFields,
                                          callback: function($$v) {
                                            _vm.configuredTableFields = $$v
                                          },
                                          expression: "configuredTableFields"
                                        }
                                      },
                                      _vm._l(
                                        _vm.configuredTableFields,
                                        function(element, idx) {
                                          return _c(
                                            "li",
                                            {
                                              key: element.key,
                                              staticClass: "list-group-item",
                                              attrs: {
                                                onselectstart: "return false"
                                              }
                                            },
                                            [
                                              _c(
                                                "b-form-checkbox",
                                                {
                                                  attrs: {
                                                    switch: "",
                                                    disabled:
                                                      _vm.configuredTableFieldsActive &&
                                                      element.show
                                                  },
                                                  on: {
                                                    input: _vm.saveTableConfig
                                                  },
                                                  model: {
                                                    value: element.show,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        element,
                                                        "show",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "element.show"
                                                  }
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "far fa-sort text-muted mr-2 handle"
                                                  }),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(element.label) +
                                                      "\n                                "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      0
                                    )
                                  : _vm._e()
                              ]
                            : _vm._e()
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("template", { slot: "footer" }, [
                        _c(
                          "div",
                          { staticClass: "actions" },
                          [
                            _c(
                              "b-button",
                              { on: { click: _vm.resetTableFields } },
                              [_vm._v("Сбросить по умолчанию")]
                            ),
                            _vm._v(" "),
                            _c(
                              "b-button",
                              {
                                attrs: { variant: "warning" },
                                on: { click: _vm.closeTableConfigurator }
                              },
                              [_vm._v("Готово")]
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }